import TridentLogo from 'es/app/visuals/images/trident-logo-new.svg?react';
import { ComponentProps } from 'react';
import cn from 'classnames';
import styles from './Logo.module.css';

type SvgProps = ComponentProps<typeof TridentLogo>;

type ImageProps = Omit<SvgProps, 'width' | 'height' | 'className'>;
type Dimensions = Pick<SvgProps, 'width' | 'height'>;
type Attributes = Pick<SvgProps, 'className'>;

type LogoProps = Dimensions &
    Attributes & {
        colour?: string;
        imageProps?: ImageProps;
    };

export const Logo = ({ className, colour, height, imageProps, width }: LogoProps) => {
    return (
        <TridentLogo style={{ width, height, fill: colour }} className={cn(className, styles.logo)} {...imageProps} />
    );
};
